module.exports = __webpack_public_path__ + "static/img/detail-bg-right.8c570923.png";